"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var SvgEmptyBell = function SvgEmptyBell(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 17 16",
    fill: "#fff",
    stroke: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.6 8.522c-.23.766 1.643 2.095 3.806 2.971.42.171.853.325 1.282.453.606.182 1.253.329 1.894.435 2.148.359 4.227.271 4.438-.435.354-1.178-1.825-1.352-1.332-4.42.493-3.067-.235-4.869-1.951-5.383-1.716-.515-3.202.749-4.655 3.403C4.628 8.2 2.953 7.344 2.6 8.522zm6.661 5.508a1.808 1.808 0 0 1-1.633 1.007c-1.09.005-1.983-.984-1.869-2.025.87.42 2.293.914 3.502 1.018z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.737 2.143c-1.716-.515-3.202.749-4.655 3.403C4.628 8.2 2.953 7.344 2.6 8.522c-.23.766 1.643 2.095 3.806 2.971.42.171.853.325 1.282.453.606.182 1.253.329 1.894.435 2.148.359 4.227.271 4.438-.435.354-1.178-1.825-1.352-1.332-4.42.493-3.067-.235-4.869-1.951-5.383zm0 0L11.12.835M7.628 15.037a1.808 1.808 0 0 0 1.633-1.007c-1.21-.104-2.631-.599-3.502-1.018-.114 1.041.778 2.03 1.869 2.025z"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgEmptyBell);
var _default = Memo;
exports["default"] = _default;